module.exports = __webpack_public_path__ + "static/media/proceedings.71a52452.png";